import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchSelectListsRequest, setInitialStateSelectLists } from 'store/selectLists/selectLists.actions'
import { setInitialStateOrders } from 'store/orders/orders.actions'
import { selectCurrentUser } from 'store/users/users.selectors'
import { checkVersionRequest } from 'store/version/version.actions'

import OrderListHeader from 'components/organisms/OrderListHeader'
import OrderListBody from 'components/organisms/OrderListBody'

import { useOrdersListPolling } from 'hooks/use-orders-list-polling'
import NotificationBanner from './components/NotificationBanner'

export const OrderListPage: React.FC = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const currentUserRole = currentUser?.role
  const currentUserRoleRef = useRef(currentUserRole)
  useOrdersListPolling()

  useEffect(() => {
    currentUserRoleRef.current = currentUserRole
  }, [currentUserRole])

  useEffect(() => {
    dispatch(checkVersionRequest())
    dispatch(fetchSelectListsRequest())

    return () => {
      dispatch(setInitialStateSelectLists())
      dispatch(setInitialStateOrders())
    }
  }, [dispatch]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="container page-content d-flex flex-column flex-grow-1">
      <NotificationBanner />
      <OrderListHeader />
      <div className="row flex-grow-1">
        <OrderListBody />
      </div>
    </div>
  )
}

export default OrderListPage
